<style scoped lang="less">
  .editHost {
    hr {
      margin: 10px;
    }
    .button {
    }
    .panel.permissions {
      padding-left: 15px;
      padding-top: 10px;
    }
  }
</style>
<template>
  <div class="columns editHost">
    <div class="column is-12">
      <div class="div-table">
        <div class="columns is-gapless">
          <div class="column is-12 card-header has-text-centered button-tools">
            <div
              class="button is-info is-pulled-left"
              @click="goBack()"
            >
              &lt; Back to list
            </div>
            <strong>Edit Host</strong>
          </div>
        </div>
        <div class="column is-12 editHost">
          <div class="columns is-centered">
            <div class="column is-narrow">
              <toggle-button
                v-model="hostData.active"
                :width="80"
                :height="30"
                :speed="480"
                :sync="true"
                :labels="{checked: 'Active', unchecked: 'Inactive'}"
                :color="{checked: '#7DCE94', unchecked: '#CCC'}"
              />
            </div>
          </div>
          <label class="label">Username</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="hostData.login"
                    type="text"
                    placeholder="Username"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>
          <label class="label">Password</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="hostData.password"
                    type="password"
                    placeholder="Password"
                    class="input"
                  >
                </p>
              </div>
            </div>
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="hostData.confirmPassword"
                    type="password"
                    placeholder="Confirm Password"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>
          <label class="label">Personal Information</label>
          <hr>
          <div class="columns is-multiline">
            <div class="column is-5">
              <label class="label">First Name</label>
              <div class="field">
                <p class="control">
                  <input
                    v-model="hostData.first"
                    type="text"
                    placeholder="First Name"
                    class="input"
                  >
                </p>
              </div>
            </div>
            <div class="column is-5">
              <label class="label">Last Name</label>
              <div class="field">
                <p class="control">
                  <input
                    v-model="hostData.last"
                    type="text"
                    placeholder="Last Name"
                    class="input"
                  >
                </p>
              </div>
            </div>
            <div class="column is-12">
              <label class="label">Email</label>
              <div class="field">
                <p class="control">
                  <input
                    v-model="hostData.email"
                    type="text"
                    placeholder="Email"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>
          <label class="label">Notes</label>
          <hr>
          <div class="columns is-multiline">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <textarea
                    v-model="hostData.notes"
                    placeholder="Notes"
                    class="textarea"
                    rows="5"
                  />
                </p>
              </div>
            </div>
          </div>
          <label class="label">Permissions & Franchise</label>
          <hr>
          <div class="columns is-multiline">
            <div class="column is-5">
              <label class="label">Franchise</label>
              <div
                v-if="franchises"
                class="field"
              >
                <div class="control is-flex">
                  <div
                    class="dropdown"
                    :class="{'is-active': franchiseDropdown}"
                  >
                    <div class="dropdown-trigger">
                      <button
                        class="button is-small"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        @click="franchiseDropdown = !franchiseDropdown"
                      >
                        <span>{{ selectedFranchise.name }}</span>
                        <span class="icon is-small">
                          <i
                            class="far fa-angle-down"
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                    </div>
                    <div
                      class="dropdown-menu"
                      role="menu"
                    >
                      <div
                        v-for="franchise in franchises"
                        class="dropdown-content"
                      >
                        <a
                          class="dropdown-item"
                          @click="selectFranchise(franchise)"
                        >
                          {{ franchise.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-5">
              <label class="label">Linked MyAHL Account</label>
              <div
                v-if="hostData.linkedMyAHLAccount != null"
                class="field"
              >
                <div class="card is-info">
                  <div class="columns">
                    <div class="column is-vcentered">
                      <div>
                        {{ hostData.linkedMyAHLAccount.first }} {{ hostData.linkedMyAHLAccount.middle }}
                        {{ hostData.linkedMyAHLAccount.last }}
                      </div>
                      <div>{{ hostData.linkedMyAHLAccount.ahlid }}</div>
                    </div>
                    <div class="column is-vcentered">
                      <div
                        class="is-pulled-right has-text-danger icon"
                        @click="removeLinkedMyAHL()"
                      >
                        <a
                          class="delete is-medium"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!hostData.linkedMyAHLAccount"
                class="field"
              >
                <div
                  class="button is-info"
                  @click="showLinkMyAHLDialog()"
                >
                  Link Account
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div
                class="accordion-title"
                :class="{'active': showPermissions}"
                @click="togglePermissions()"
              >
                Permissions
              </div>
              <div
                v-if="showPermissions"
                class="panel permissions"
              >
                <div
                  v-for="permission, index in hostData.permissions_list"
                  class="field"
                >
                  <p class="control">
                    <input
                      v-model="permission.hasPermission"
                      type="checkbox"
                      class="checkbox"
                      :checked="permission.hasPermission"
                    > &nbsp;{{ permission.description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <hr>
              <div class="is-pulled-right">
                <div
                  class="button is-info"
                  @click="saveHost()"
                >
                  Save
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import LinkMyAHL from './LinkMyAHL.vue'

  export default {
    name: 'ToolsEditHost',
    components: {
      'link-my-ahl': LinkMyAHL
    },
    props: {
      token: {
        type: String,
      },
      user: {
        type: Object,
      },
      isNew: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        hostData: {
          password: null,
          confirmPassword: null,
          id: null,
          username: '',
          first: '',
          last: '',
          email: '',
          franchise: {},
          linkedMyAHLAccount: null,
          permissions_list: []
        },
        selectedFranchise: {},
        showPermissions: false,
        linkMyAHLDialogVisible: false,
        franchises: [],
        franchiseDropdown: false
      }
    },
    mounted: function () {
      this.getFranchises()
    },
    methods: {
      create() {
        console.log(this.$route.params)
      },
      togglePermissions() {
        this.showPermissions = !this.showPermissions
      },
      saveHost() {
        if (this.validateFields()) {
          let data = {
            token: this.token,
            hostData: this.hostData
          }
          let url = `admin/hosts/save`
          this.$axios({
            method: 'POST',
            url,
            headers: {
              Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            data
          })
            .then((res) => {
              this.$emit('message', {
                error: res.data.error,
                message: res.data.message
              })
            })
            .catch((error) => {
              console.log(error)
            })
        }
      },
      validateFields() {
        let mandatoryFields = {
          first: 'First name is missing',
          last: 'Last name is missing',
          login: 'Username is missing',
          email: 'Email is missing'
        }
        console.log(this.hostData)
        for (var x in mandatoryFields) {
          if ((this.hostData[x] && this.hostData[x].length === 0) || !this.hostData[x]) {
            this.$emit('message', {
              error: true,
              message: mandatoryFields[x]
            })
            return false
          }
        }
        if (this.hostData.confirmPassword !== this.hostData.password) {
          this.$emit('message', {
            error: true,
            message: 'Passwords do not match'
          })
        }
        return true
      },
      showLinkMyAHLDialog() {
        this.linkMyAHLDialogVisible = !this.linkMyAHLDialogVisible
        if (this.linkMyAHLDialogVisible === true) {
          this.$modal.show(LinkMyAHL, {linkToMyAHL: this.linkToMyAHL, token: this.token}, {
            name: 'linkMyAHL',
            resizable: true,
            adaptive: true,
            draggable: true,
          }, {
            'before-close': this.beforeClose
          })
        }
      },
      goBack() {
        this.$router.push('/admin/hosts')
      },
      beforeOpen() {
        alert('opening')
      },
      linkToMyAHL(id, first, middle, last) {
        this.hostData.linkedMyAHLAccount = {ahlid: id, first: first, middle: middle, last: last}
        this.linkMyAHLDialogVisible = false;
        this.$modal.hide('linkMyAHL')
      },
      beforeClose() {
        this.linkMyAHLDialogVisible = false
      },
      removeLinkedMyAHL() {
        this.hostData.linkedMyAHLAccount = null
      },
      selectFranchise(franchise) {
        this.hostData.franchise = franchise
        this.selectedFranchise = franchise
        this.franchiseDropdown = false
      },
      getFranchises() {
        let url = `admin/hosts/getfranchises`
        let data = {
          token: this.token
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
            this.getHostInfo(this.$route.params.id)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      getHostInfo(id) {
        let getUrl = `admin/hosts/get`
        let data = {
          token: this.token,
          hostId: id
        }
        this.$axios({
          method: 'POST',
          url: getUrl,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.hostData = res.data
            this.hostData.password = null
            this.hostData.confirmPassword = null
            for (var x in this.franchises) {
              if (this.franchises[x].id === this.hostData.franchise) {
                this.hostData.franchise = this.franchises[x]
                this.selectedFranchise = this.franchises[x]
                break
              }
            }
            this.updateActive(res.data.active)
          })
          .catch((error) => {
            console.log(error.response)
          })
      },
      updateActive(result) {
        if (result) {
          this.hostData.active = result
        } else {
          this.hostData.active = !this.hostData.active
        }
      }
    }
  }
</script>
